import styled from 'styled-components';

export const FeaturesBlockStyled = styled.section`
  padding: 60px 0;
  background-color: #e2e6e8;

  @media screen and (min-width: 992px) {
    padding: 120px 0;
  }
`;

export const List = styled.ul`
  list-style: none;

  @media screen and (min-width: 992px) {
    position: relative;
    display: grid;
    grid-column: 2/12;
    grid-template-columns: 1fr 1fr 1fr;
    grid-row-gap: 100px;
    padding: 0;
    margin: 0;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 1px;
      transform: translateY(-50%);
      background-color: rgba(92, 102, 111, 0.3);
    }
  }
`;

export const ListItem = styled.li`
  position: relative;
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }

  @media screen and (min-width: 992px) {
    margin-bottom: 0;
  }
`;

export const Figure = styled.figure`
  display: flex;
  align-items: center;

  img {
    margin-right: 24px;
  }

  figcaption {
    font-size: 18px;
    line-height: 1.3;
    font-weight: 500;
    color: #333333;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/FeaturesBlock/styled.js